import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import WeChatService from '&/components/ConsultQRCodeModal/WeChatService';
import './index.exclude.scss';

const ConsultQRCodeModal = () => {
    usePreventDefault();

    const closeHddModal = () => {
        try {
            window.external.DispatchFun('StartPage', 'CloseRender', '');
        } catch {}
    };

    useEffect(() => {
        const wrap = document.querySelector('.hdc');
        wrap.style.backgroundColor = 'transparent';
        return () => {
            wrap.style.backgroundColor = '#f4f6fc';
        };
    }, []);

    return (
        <div className="wechat-service-wrap">
            <WeChatService onClose={closeHddModal} />
        </div>
    );
};
export default ConsultQRCodeModal;
